import sirenParser from 'siren-parser';
import { entityStore } from './entity-store.js';

export async function getSiren(hrefOrLinkEntity, { bypassCache = false } = {}) {
  if (!hrefOrLinkEntity) {
    return;
  }
  const href = typeof hrefOrLinkEntity === 'string' ? hrefOrLinkEntity : hrefOrLinkEntity.href;
  const { entity } = await entityStore.fetchWait(href, bypassCache);
  return entity && sirenParser(entity);
}

/**
 * Gets the cached entity, without causing the entity to be fetched if it is not currently in the cache.
 * @param {string | Link} hrefOrLinkEntity an href or a Siren link entity.
 * @returns {Promise<Entity | undefined>} the cached entity.
 */
export async function getCachedSiren(hrefOrLinkEntity) {
  if (!hrefOrLinkEntity) {
    return;
  }
  const href = typeof hrefOrLinkEntity === 'string' ? hrefOrLinkEntity : hrefOrLinkEntity.href;
  const { entity } = await entityStore.get(href);
  return entity && sirenParser(entity);
}
